import React, { useState } from 'react';
import PricingPlansTable from './PricingPlansTable';
import { Button } from '../../../ui';

import pricingPlans from './pricingPlans.json';

const PricingPlans = props => {
  const [activeTab, setActiveTab] = useState('activation');

  return (
    <div id="pricing-plans" className="bg-white">
      <div className="md:container">
        <div className="flex flex-col items-center h-full w-full justify-center gap-[48px]">
          <h2 className={'max-w-[500px] font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black md:text-center mt-[48px]'}>
            SEO Pricing Plans
          </h2>
          <div className="flex flex-col w-full">
            <div className="mb-[8px] bg-[#EEEAF9] rounded-[5px] md:hidden blok flex flex-row gap-[8px] w-full justify-between py-[4px]">
              <button
                className={`p-[8px] rounded-[5px] text-[16px] font-[500] leading-[20px] ${activeTab === 'activation' ? 'bg-white text-[#09af77]' : 'bg-[#EEEAF9]'}`}
                onClick={() => setActiveTab('activation')}
              >
                Plan for Activation
              </button>
              <button
                className={`p-[8px] rounded-[5px] text-[16px] font-[500] leading-[20px] ${activeTab === 'acceleration' ? 'bg-white text-[#09af77]' : 'bg-[#EEEAF9]'}`}
                onClick={() => setActiveTab('acceleration')}
              >
                Plan for Acceleration
              </button>
              <button
                className={`p-[8px] rounded-[5px] text-[16px] font-[500] leading-[20px] ${activeTab === 'victory' ? 'bg-white text-[#09af77]' : 'bg-[#EEEAF9]'}`}
                onClick={() => setActiveTab('victory')}
              >
                Plan for Victory
              </button>
            </div>
            <PricingPlansTable data={pricingPlans} currency={props.currency} active={activeTab} />
            <div className="w-full bg-[#09af77] flex md:flex-row flex-col justify-center items-center py-[48px] md:py-[24px] gap-[24px] md:gap-[100px] md:mb-[48px] mb-0">
              <p className="max-w-[344px] md:max-w-[400px] text-white text-[20px] md:text-[24px] text-center font-[600] leading-[29px] ">
                Can't Find the Right Package for your marketing plan? We offer guaranteed SEO options tailored to your needs. Let's Customize Your SEO
                Plan!
              </p>
              <a href={`/seo/seo-form`}>
                <Button variant="secondary" narrowing="both" className=" md:w-auto">
                  Create My SEO Plan
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPlans;
